export default "__VITE_ASSET__DT30oUjI__"